import React, { useEffect, useState } from "react";
import { useParams, Outlet, NavLink, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft, LayoutDashboard, Edit, Ticket as TicketIcon, Users, ScanLine } from "lucide-react";
import { api } from "../../lib/api";

export default function ManageEventLayout() {
    const { id } = useParams();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [event, setEvent] = useState(null);

    useEffect(() => {
        (async () => {
            try {
                const { data } = await api.get(`/api/organizer/events/${id}/manage`);
                setEvent(data);
            } catch {}
        })();
    }, [id]);

    const links = [
        { to: `/organizer/events/${id}/manage/dashboard`, label: t("organizer.dashboard"), icon: LayoutDashboard, tid: "tab-dashboard" },
        { to: `/organizer/events/${id}/manage/edit`, label: t("organizer.edit_event"), icon: Edit, tid: "tab-edit" },
        { to: `/organizer/events/${id}/manage/sold`, label: t("organizer.sold_tickets"), icon: TicketIcon, tid: "tab-sold" },
        { to: `/organizer/events/${id}/manage/staff`, label: t("organizer.staff"), icon: Users, tid: "tab-staff" },
        { to: `/organizer/events/${id}/manage/checkin`, label: t("organizer.checkin"), icon: ScanLine, tid: "tab-checkin" },
    ];

    return (
        <div data-testid="manage-event-layout" className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10 space-y-6">
            <button
                data-testid="back-to-main"
                onClick={() => navigate("/organizer/listings")}
                className="inline-flex items-center gap-1 text-sm font-semibold text-muted-foreground hover:text-foreground"
            >
                <ArrowLeft className="h-4 w-4" />
                {t("organizer.back")}
            </button>
            <div>
                <p className="text-xs text-muted-foreground uppercase tracking-wider font-semibold">{t("organizer.manage_event")}</p>
                <h1 className="font-heading font-black text-2xl md:text-3xl">{event?.title || "-"}</h1>
            </div>

            <div className="border-b border-border pb-2" data-testid="manage-event-tabs">
                <div className="grid grid-cols-2 gap-1.5 md:flex md:gap-1 md:flex-wrap">
                    {links.map(({ to, label, icon: Icon, tid }) => (
                        <NavLink
                            key={to}
                            to={to}
                            data-testid={tid}
                            className={({ isActive }) =>
                                `flex items-center justify-center md:justify-start gap-2 px-3 md:px-4 py-2 rounded-xl md:rounded-t-xl md:rounded-b-none text-sm font-semibold transition-colors ${isActive ? "bg-foreground text-background" : "bg-muted hover:bg-border"}`
                            }
                        >
                            <Icon className="h-4 w-4 flex-shrink-0" />
                            <span className="truncate">{label}</span>
                        </NavLink>
                    ))}
                </div>
            </div>

            <Outlet context={{ event }} />
        </div>
    );
}
